import { render } from "./UeExpensesListView.vue?vue&type=template&id=0866dc27&scoped=true"
import script from "./UeExpensesListView.vue?vue&type=script&lang=js"
export * from "./UeExpensesListView.vue?vue&type=script&lang=js"

import "./UeExpensesListView.vue?vue&type=style&index=0&id=0866dc27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0866dc27"]])

export default __exports__